import { Navigate, Outlet } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/hooks/use-auth';

export function AuthLayout() {
    const { user, isAuthenticated, isLoading } = useAuth();

    // Hold the login form until the initial "am I already authenticated?" bootstrap check
    // settles — submitting login while that check is still in flight races it for the
    // session/CSRF cookie and can produce a spurious 419.
    if (isLoading) {
        return (
            <div className="flex min-h-screen items-center justify-center gap-2 text-sm text-muted-foreground">
                <Loader2 className="size-4 animate-spin" /> Loading…
            </div>
        );
    }

    if (isAuthenticated) {
        return <Navigate to={user?.is_platform_admin ? '/admin' : '/dashboard'} replace />;
    }

    return (
        <div className="flex min-h-screen items-center justify-center bg-muted/30 px-4">
            <div className="w-full max-w-sm">
                <div className="mb-8 flex items-center justify-center gap-2">
                    <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary text-base font-bold text-primary-foreground">
                        A
                    </div>
                    <span className="text-lg font-semibold">AIPA</span>
                </div>
                <Outlet />
            </div>
        </div>
    );
}
